export default "__VITE_ASSET__BEhgH6n3__"